// Grille tarifaire indicative — DS Serrurier Urgence
// Source de vérité partagée par la page /tarifs et le bandeau saisonnier
// (SeasonalBanner.jsx), pour que la date de fin d'offre reste cohérente.

// Date de fin de l'offre "serrure carénée blindée A2P à 990€ TTC" (inclusif).
export const OFFRE_ETE_FIN = "2026-07-31";

export const TARIFS = [
  {
    prestation: "Ouverture de porte claquée",
    tarif: "à partir de 89€",
  },
  {
    prestation: "Ouverture de porte fermée à clé",
    tarif: "à partir de 189€",
  },
  {
    prestation: "Remplacement de pièces (cylindre, serrure...)",
    tarif: "sur devis, selon catalogue",
  },
  {
    prestation: "Installation serrure carénée blindée A2P",
    tarif: "990€ TTC",
    highlight: true,
  },
  {
    prestation: "Poignée blindée (marque française)",
    tarif: "249€",
  },
  {
    prestation: "Blindage de porte",
    tarif: "sur devis — matériel européen certifié",
  },
  {
    prestation: "Judas connecté",
    tarif: "à partir de 159€ TTC selon modèle",
  },
  {
    prestation: "Déplacement",
    tarif: "offert dans un rayon de 5 km, 39€ au-delà",
  },
];
